<template>
  <div id="app">
    <Header ref="header" />
    <router-view class="routerview"
                 @gologininfo="gologininfodata" />
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
export default {
  components: { Header, Footer },
  name: 'App',
  methods: {
    gologininfodata () {
      this.$refs.header.gologininfodata();
    }
  }
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
#content {
  /* margin-top: 120px; */
  min-height: 800px;
  height: auto;
}
.routerview {
  min-height: 800px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue